SC.studios_list = (function () {
  var api = {};

  var init = function () {
    regionFilters();
    getStudiosGrid();
    lightFaveStudios();
    isStudioIdFavorite();
    applyFavSort();
    favIt();
    initializeMap();
    setAnalyticsListeners();

    // Update region studios if the user go back using the browser
    window.onpopstate = onPopStateHistory;
  };

  var onPopStateHistory = function (event) {
    var notPushHistoryState = true;
    var regionId = 0;

    if (event.state && event.state.region_id) {
      regionId = event.state.region_id;
    } else if (window.location.pathname === '/studios/') {
      regionId = 1;
    }

    $('#region-listbox li a[data-id="' + regionId + '"]').trigger('click', [notPushHistoryState]);
  };

  var regionFilters = function () {
    // update active state
    var regionId = $('.region-dropdown .region').data('region-id');
    regionId = regionId === 'all' ? 0 : regionId;
    $('.region-select-row a').removeClass('active');
    $('.region-dropdown-list .region-select-row li a[data-id="' + regionId + '"]').addClass('active');

    $('.studios-container').on('click', '.region-select-row a', function () {
      SC.analytics.mp.sendEvent('Click New Region', 'navigation', {
        'Region Name': $(this).text().trim(),
        'Location': 'Studio Selection'
      }, 'Studio Selection');
    });
  };

  var setAnalyticsListeners = function () {
    var $studioContainer = $('.studios-container');

    $studioContainer.on('click', '.studio-link', function () {
      var studioName = $(this).find('.name').text();
      SC.analytics.mp.sendEvent('Click Studio Page', 'navigation',
        {
          'Studio Name': studioName,
          'Context': 'Studio List',
          'Location': 'Studio Selection'
        }, 'Studio Selection');
    });
  };

  var getStudiosGrid = function () {
    $('.studios-container .region-select-row a').on('click', function (e, notPushHistoryState) {
      e.preventDefault();

      var changeRegionBtn = document.getElementById('region_button');
      var regionId = String($(this).data('id'));
      var url = '/studios/' + (regionId === '0' ? 'all' : regionId) + '/partial/';
      var $selectedRegion = $(this);
      var regionName = regionId === '0' ? 'all' : decodeURIComponent( $selectedRegion.data('region-name').toLowerCase()).replace(/ /g, '_');

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'html',
        success: function (data) {
          // update pretty url
          if (!notPushHistoryState) {
            history.pushState(
              {
                region_id: regionId,
                region_name: regionName
              },
              '',
              ('/studios/' + regionName + '/')
            );
          }

          // update studio list
          $('.studio-list').html(data);
          // light em up
          lightFaveStudios();
          favIt();
          applyFavSort();
          // ui update selected region and close menu
          $('.region-dropdown .region').html($selectedRegion.html());
          $('.region-select-row a').removeClass('active');
          $($selectedRegion).addClass('active');
          $('.region-dropdown-list').removeClass('block');
          changeRegionBtn.focus();
          changeRegionBtn.setAttribute('aria-expanded', 'false');
          $('.studios-header-options, .region-dropdown').toggleClass('full-height');
          // redraw map
          initializeMap();
        },
        error: function () {
          confirmation(null, 'oops! an error occurred while submitting your request. try that again!');
        }
      });
    });
  };

  /**
   * Loop through all the studios on the page and if they're favorite, make the lil heart light up.
   */

  var lightFaveStudios = function () {
    if (typeof window.soulcycle.favoriteStudioIds !== 'undefined') {
      for (var key in window.soulcycle.favoriteStudioIds) {
        if (Object.prototype.hasOwnProperty.call(window.soulcycle.favoriteStudioIds, key)) {
          var favStudioId = window.soulcycle.favoriteStudioIds[key];
          var $favoriteStudioImg = $('img.fav[data-studio-id=' + favStudioId + ']');

          $favoriteStudioImg
            .attr({
              'alt': 'Remove ' + $favoriteStudioImg.data('studio-title') + ' as favorite',
              'aria-selected': 'true'
            })
            .closest('div.fav-class')
            .addClass('faved');
        }
      }
    }
  };

  /**
   * Given a studioId, returns a boolean as to whether the studio is one of the user's favorites.
   */

  var isStudioIdFavorite = function (studioId) {
    if (typeof window.soulcycle.favoriteStudioIds === 'undefined') {
      return false;
    }

    for (var key in window.soulcycle.favoriteStudioIds) {
      if (Number.parseInt(window.soulcycle.favoriteStudioIds[key], 10) === studioId) {
        return true;
      }
    }

    return false;
  };

  /**
   * Apply the favorite-sort to any studio-list div.
   */

  var applyFavSort = function () {
    $('div.studio-blocks').each(function () {
      var $studioList = $(this);

      var favStudios = [];
      var normalStudios = [];

      $studioList.children('.studio-detail').each(function (key, studio) {
        if (isStudioIdFavorite($(studio).data('studio-id'))) {
          favStudios.push(studio);
        } else {
          normalStudios.push(studio);
        }
      });

      $studioList.append(favStudios.concat(normalStudios));
    });
  };

  var favIt = function () {
    $('body.logged-in .studios-elements .fav').on('click keydown', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      var studioId = $(this).data('studio-id');
      var studioTitle = $(this).data('studio-title');
      var $container = $(this).closest('.fav-class');
      var wasFaved = $container.hasClass('faved');
      var enabled;
      var alternativeText = 'Favorite ' + studioTitle;

      if (wasFaved === true) {
        $container.removeClass('faved');
        enabled = 0;
        for (var key in window.soulcycle.favoriteStudioIds) {
          if (window.soulcycle.favoriteStudioIds[key] === studioId) {
            window.soulcycle.favoriteStudioIds.splice(key, 1);
          }
        }
      } else {
        $container.addClass('faved');
        enabled = 1;
        window.soulcycle.favoriteStudioIds.push(parseInt(studioId, 10));
        alternativeText = 'Remove ' + studioTitle + ' as favorite';
      }

      SC.utils.toggleFavoriteStudio(studioId, enabled);
      $(this).attr({
        'alt': alternativeText,
        'aria-selected': !wasFaved
      });

      /**
       * Old GA sendEvent - studios fav
       * Deprecated: Will be removed soon.
       *
       * action = faved
       * label = studio id
       */
      if ( enabled ) {
        SC.analytics.ga.sendEvent('studios', 'faved', studioId.toString());
      }

      var studioData = $(this).data();
      var eventData = {
        'Location': studioData.location,
        'Studio Name': studioData.studioTitle,
        'Studio Location': studioData.studioRegion
      };
      SC.analytics.mp.sendEvent(enabled ? 'Click to Favorite a Studio' :
        'Click to Unfavorite a Studio', 'navigation', eventData, studioData.location);
    });
  };

  var initializeMap = function () {
    var MY_MAPTYPE_ID = 'soul_style';
    var featureOpts = [
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#e9e9e9'
          },
          {
            'lightness': 17
          }
        ]
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f5f5'
          },
          {
            'lightness': 20
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 17
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 29
          },
          {
            'weight': 0.2
          }
        ]
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 18
          }
        ]
      },
      {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 16
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f5f5'
          },
          {
            'lightness': 21
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dedede'
          },
          {
            'lightness': 21
          }
        ]
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'color': '#ffffff'
          },
          {
            'lightness': 16
          }
        ]
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'saturation': 36
          },
          {
            'color': '#333333'
          },
          {
            'lightness': 40
          }
        ]
      },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'transit',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f2f2f2'
          },
          {
            'lightness': 19
          }
        ]
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#fefefe'
          },
          {
            'lightness': 20
          }
        ]
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#fefefe'
          },
          {
            'lightness': 17
          },
          {
            'weight': 1.2
          }
        ]
      }
    ];

    var mapOptions = {
      zoom: 12,
      center: new google.maps.LatLng(40.790278, -73.959722),
      disableDefaultUI: true,
      mapTypeId: MY_MAPTYPE_ID,
      scrollwheel: false,
      zoomControl: true,
      draggable: true,
      minZoom: 3,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      }
    };

    if ($(window).width() < 480) {
      mapOptions.zoomControl = false;
    } else if (($(window).width() === 1024 || $(window).width() === 768) && $.browser.device === 'ipad') {
      mapOptions.zoomControl = false;
      mapOptions.scaleControl = false;
    }

    map = new google.maps.Map(document.getElementById('studios-map-canvas'), mapOptions);

    var allowedBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(-80, -180),           // bottom left corner of map
      new google.maps.LatLng(80, 180)            // top right corner
    );

    var lastValidCenter = map.getCenter();

    google.maps.event.addListener(map, 'center_changed', function () {
      if (allowedBounds.contains(map.getCenter())) {
        // still within valid bounds, so save the last valid position
        lastValidCenter = map.getCenter();
        return;
      }
      // not valid anymore => return to last valid position
      map.panTo(lastValidCenter);
    });

    var styledMapOptions = {
      name: 'Soul Style'
    };

    var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);

    map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

    var infowindow = new google.maps.InfoWindow({
      maxWidth: 200
    });

    var marker;
    var markers = [];

    // Mouse out marker to close info
    $(function () {
      enquire.register('screen and (max-width : 1440px)', function () {
        if (map.getZoom() < 3) {
          map.setZoom(3);
        }
        map.setOptions({minZoom: 3});
      }).register('screen and (min-width : 1441px)', function () {
        if (map.getZoom() < 4) {
          map.setZoom(4);
        }
        map.setOptions({minZoom: 4});
      });
    });

    // Add the markers and infowindows to the map
    $('.map-marker').each(function (index) {
      var $this = $(this);
      var mapInfoWindowData = $this.find('.map-info-window').data();
      var lat = parseFloat(mapInfoWindowData.lat);
      var lon = parseFloat(mapInfoWindowData.lon);
      var studio = $this.html();
      var studioType = mapInfoWindowData.studioType;

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lon),
        map: map,
        icon: '/assets/images/marker-' + studioType + '.svg'
      });

      markers.push(marker);

      // Mouse over marker to get info
      google.maps.event.addListener(marker, 'mouseover', (function (marker) {
        return function () {
          infowindow.setContent(studio);
          infowindow.open(map, marker);
        };
      })(marker, index));

      google.maps.event.addListener(marker, 'mouseout', (function () {
        return function () {
          if ($.browser.isTouchCapable) {
            infowindow.close();
          }
        };
      })(marker, index));

      // Click map and close info
      google.maps.event.addListener(map, 'click', (function () {
        return function () {
          infowindow.close();
        };
      })());
    });

    // First detach all the old map event handlers.
    // Then reattach them again so the mParticle event only fires once.
    $(document).off('click', '.map-info-window a');
    $(document).on('click', '.map-info-window a', function () {
      var eventData = {
        'Studio Name': $(this).data('studio-title'),
        'Context': 'Map',
        'Location': 'Studio Selection'
      };
      SC.analytics.mp.sendEvent('Click Studio Page', 'navigation', eventData, 'Studio Selection');
    });

    function autoCenter() {
      //  Create a new viewpoint bound
      var bounds = new google.maps.LatLngBounds();
      //  Go through each...
      $.each(markers, function (index, marker) {
        bounds.extend(marker.position);
      });


      if (markers.length > 1) {
        //  Fit these bounds to the map
        map.fitBounds(bounds);
      } else {
        // Make sure not to zoom in too far initially
        map.setCenter(bounds.getCenter());
        map.setZoom(12);
      }
    }

    autoCenter();
  };

  init();
  return api;
})();
